import { Plot } from "../models/Plot";
import { PlotField } from "../models/PlotField";
import { PlotSchema } from "../models/PlotSchema";



export class PlottingTypeGuardService {

    private static readonly PLOT_TYPES_THAT_SUPPORT_CHILD_RULES = [];

    public static isPlot(obj: unknown): obj is Plot {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isPlotField(obj: unknown): obj is PlotField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isPlotSchema(obj: unknown): obj is PlotSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedPlotSchemaUi(plotSchema: PlotSchema): boolean {
        return this.isPlotSchema(plotSchema)
            && plotSchema.ui != null
            && typeof plotSchema.ui === 'object'
            && Array.isArray(plotSchema.ui.field_groups)
            && plotSchema.ui.field_groups.length > 0
            && plotSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildPlots(obj: unknown): boolean {

        // any PlotField with item_schema or payload_template
        // Note that we currently do not support payload_templates for plots
        return (this.isPlot(obj) && this.plotTypeSupportsChildPlots((obj as Plot)._type))
            || (this.isPayloadTemplatePlotSchema(obj)  //TODO: make this recursive
                && this.plotTypeSupportsChildPlots((obj as PlotSchema).payload_template?.type));

    }

    public static isPayloadTemplatePlotSchema(obj: unknown): boolean {
        return this.isPlotSchema(obj) && (obj as PlotSchema).payload_template != null;
    }

    public static plotTypeSupportsChildPlots(ruleType?: string): boolean {
        return this.PLOT_TYPES_THAT_SUPPORT_CHILD_RULES.find(x => ruleType === x) != null;
    }

    public static isNonEmptyPlotObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }

}